var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"notfound"},[_vm._v("404")]),_vm._v(" "),_c('h1',[_vm._v("Səhifə tapılmadı")]),_vm._v(" "),_c('p',[_vm._v("Bağışlayın, axtardığınız səhifə mövcud deyil.")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Ana səhifəyə qayıt")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afd6c09","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 83
// module chunks = 0